import { render } from "./Employees.vue?vue&type=template&id=4ad984e9&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"

import "./Employees.vue?vue&type=style&index=0&id=4ad984e9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad984e9"]])

export default __exports__